import React, { Component } from 'react';
import Aux from '../../../_hoc/_Aux';
import { Modal, GreyBox, BoxTitle, Text, Button, Flex, FlexColumn, Spacer, Link } from 'components';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';

class Confirm extends Component {

    render () {
        return (
            <Modal blurClicked={this.props.onCancel}>
                <GreyBox valign="center" msg_inside={this.props.msg_inside ? this.props.msg_inside : null} cols={this.props.cols ? this.props.cols : 1}>
                    <BoxTitle>{this.props.title}</BoxTitle>
                    <Text>{this.props.text}</Text>
                    <Flex>
                        {this.props.onCancel ? (
                        <Aux>
                          <FlexColumn col="2">
                              <Button value={this.props.cancelButtonValue} onClick={this.props.onCancel} theme="light" type="button"/>
                          </FlexColumn>
                          <FlexColumn col="2">
                              <Button value={this.props.confirmButtonValue} onClick={this.props.onConfirm} type="button"/>
                          </FlexColumn>
                        </Aux>
                        ) : (
                            <Button value={this.props.confirmButtonValue} onClick={this.props.onConfirm} type="button"/>
                        )}
                    </Flex>
                    {this.props.smallText ? (
                      <Aux>
                        <Spacer height="15px" />
                        <Text size="small" align="center">
                           {this.props.smallText}
                        </Text>
                      </Aux>
                    ) : null }
                </GreyBox>
            </Modal>
        )
    }
}

Confirm.propTypes = {
  onConfirm: PropTypes.func.isRequired
};

Confirm.defaultProps = {
  title : (<Translate id="global.confirm.title" />),
  text : (<Translate id="global.confirm.text" />),
  cancelButtonValue : (<Translate id="global.confirm.cancel" />),
  confirmButtonValue : (<Translate id="global.confirm.confirm" />)
};

export default Confirm;


// WEBPACK FOOTER //
// ./src/components/organisms/Confirm/index.js